const apiUrl = process.env.REACT_APP_API_URL;
export const GetInscripcionsIdDocumentsIdDownload = async ( id_inscr: string, uid: string,  page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions/${id_inscr}/document/${uid}/download`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const data = await response.blob();
        return data;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
